module.exports = __webpack_public_path__ + "static/media/EmotionalRegulationSystems.24aa742e.svg";